import { render, staticRenderFns } from "./LimitUpOrder.vue?vue&type=template&id=63b25101&lang=pug"
import script from "./LimitUpOrder.vue?vue&type=script&lang=js"
export * from "./LimitUpOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports